import { render, staticRenderFns } from "./_RestaurantInfo.vue?vue&type=template&id=47ccd441"
import script from "./_RestaurantInfo.vue?vue&type=script&lang=js"
export * from "./_RestaurantInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports